<template>
  <div style="padding: 20px">
    <el-card>
      <template #header>
        <div style="display:flex;justify-content:space-between;align-items:center">
          <span>师徒关系管理</span>
          <el-button size="small" @click="openArchive">阶段成果归档</el-button>
        </div>
      </template>
      <el-form :inline="true" @submit.prevent>
        <el-form-item label="状态">
          <el-select v-model="query.status" placeholder="全部" clearable style="width:140px">
            <el-option label="已结对" :value="1" />
            <el-option label="进行中" :value="2" />
            <el-option label="已完成" :value="3" />
            <el-option label="已解绑" :value="4" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="load">查询</el-button>
          <el-button @click="reset">重置</el-button>
          <el-button type="success" @click="pairVisible = true">新建结对</el-button>
          <el-button type="warning" @click="importVisible = true">批量导入</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="tableData" border v-loading="loading" style="width:100%">
        <el-table-column prop="relation.id" label="ID" width="80" />
        <el-table-column prop="mentorName" label="导师" />
        <el-table-column prop="apprenticeName" label="徒弟" />
        <el-table-column label="阶段" width="110">
          <template #default="{row}">{{ stageText(row.relation.stage) }}</template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template #default="{row}">
            <el-tag :type="statusTag(row.relation.status)">{{ statusText(row.relation.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="relation.pairPeriodStart" label="结对周期" width="200">
          <template #default="{row}">{{ row.relation.pairPeriodStart }} ~ {{ row.relation.pairPeriodEnd }}</template>
        </el-table-column>
        <el-table-column label="操作" width="320" fixed="right">
          <template #default="{row}">
            <el-button size="small" type="primary" @click="showProgress(row.relation.id)">进度</el-button>
            <el-button size="small" @click="goRadar(row.relation.id)">雷达</el-button>
            <el-button size="small" type="warning" :disabled="row.relation.status===4" @click="changeStage(row)">阶段流转</el-button>
            <el-button size="small" type="danger" :disabled="row.relation.status===4" @click="doUnpair(row.relation.id)">解绑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="margin-top:12px"
        background
        layout="prev, pager, next, total"
        :total="total"
        :page-size="query.size"
        @current-change="onPage" />
    </el-card>

    <!-- 新建结对（P0，HR 代建，支持跨校区跨城市） -->
    <el-dialog v-model="pairVisible" title="新建结对" width="520px">
      <el-form label-width="90px">
        <el-form-item label="导师">
          <el-select v-model="pairForm.mentorId" filterable remote reserve-keyword :remote-method="searchMentor" :loading="coachLoading" placeholder="输入姓名/手机号搜索" style="width:100%">
            <el-option v-for="c in mentorOptions" :key="c.coachid" :label="c.coachname + '（ID:' + c.coachid + '）'" :value="c.coachid" />
          </el-select>
        </el-form-item>
        <el-form-item label="徒弟">
          <el-select v-model="pairForm.apprenticeId" filterable remote reserve-keyword :remote-method="searchApprentice" :loading="coachLoading" placeholder="输入姓名/手机号搜索" style="width:100%">
            <el-option v-for="c in apprenticeOptions" :key="c.coachid" :label="c.coachname + '（ID:' + c.coachid + '）'" :value="c.coachid" />
          </el-select>
        </el-form-item>
        <el-form-item label="周期开始">
          <el-date-picker v-model="pairForm.pairPeriodStart" type="date" value-format="YYYY-MM-DD" placeholder="选择日期" style="width:100%" />
        </el-form-item>
        <el-form-item label="周期结束">
          <el-date-picker v-model="pairForm.pairPeriodEnd" type="date" value-format="YYYY-MM-DD" placeholder="选择日期" style="width:100%" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="pairVisible = false">取消</el-button>
        <el-button type="primary" :loading="pairing" @click="doPair">保存</el-button>
      </template>
    </el-dialog>

    <!-- 批量导入（P0） -->
    <el-dialog v-model="importVisible" title="批量导入结对" width="620px">
      <el-alert type="info" :closable="false" show-icon
        title="每行一条：导师coachId,徒弟coachId,周期开始,周期结束，逗号分隔；商学院整体结对，支持跨校区跨城市" />
      <el-input v-model="importText" type="textarea" :rows="8" style="margin-top:12px"
        placeholder="示例：
1001,2001,2026-01-01,2026-12-31
1002,2002,2026-01-01,2026-12-31" />
      <div v-if="importResult" style="margin-top:12px">
        <el-alert :type="importResult.failCount ? 'warning' : 'success'" :closable="false" show-icon
          :title="'成功 ' + importResult.successCount + ' 条，失败 ' + importResult.failCount + ' 条'" />
        <el-table v-if="importResult.failed && importResult.failed.length" :data="importResult.failed" border size="small" style="margin-top:8px">
          <el-table-column prop="index" label="行号" width="60" />
          <el-table-column prop="reason" label="失败原因" />
        </el-table>
      </div>
      <template #footer>
        <el-button @click="importVisible = false; importResult = null">关闭</el-button>
        <el-button type="primary" :loading="importing" @click="doImport">开始导入</el-button>
      </template>
    </el-dialog>
    <!-- 培养进度总览 -->
    <el-dialog v-model="progressVisible" :title="progressTitle" width="680px">
      <div v-loading="progressLoading" style="min-height:120px">
        <template v-if="progress">
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="导师">{{ progress.mentorName }}</el-descriptions-item>
            <el-descriptions-item label="徒弟">{{ progress.apprenticeName }}</el-descriptions-item>
            <el-descriptions-item label="阶段">{{ stageText(progress.relation.stage) }}</el-descriptions-item>
            <el-descriptions-item label="状态">{{ statusText(progress.relation.status) }}</el-descriptions-item>
            <el-descriptions-item label="结对周期">{{ progress.relation.pairPeriodStart }} ~ {{ progress.relation.pairPeriodEnd }}</el-descriptions-item>
            <el-descriptions-item label="完成度">
              <el-progress :percentage="progress.progressPercent" :stroke-width="14" />
            </el-descriptions-item>
          </el-descriptions>

          <el-table :data="progressRows" border size="small" style="margin-top:12px">
            <el-table-column prop="name" label="环节" width="150" />
            <el-table-column prop="status" label="完成情况" />
          </el-table>

          <el-descriptions v-if="progress.taskReceived" :column="2" border size="small" style="margin-top:12px">
            <el-descriptions-item label="任务接收">{{ progress.taskReceived }} 个</el-descriptions-item>
            <el-descriptions-item label="任务提交">{{ progress.taskSubmitted }} 个</el-descriptions-item>
          </el-descriptions>

          <el-alert v-if="progress.radar" type="info" :closable="false" show-icon style="margin-top:12px"
            :title="'最新健康度：' + healthText(progress.radar.healthType) + '（学习' + progress.radar.learningScore + ' / 影响' + progress.radar.influenceScore + ' / 乐趣' + progress.radar.funScore + ' / 回报' + progress.radar.rewardScore + '）'" />

          <!-- 帮带时间轴（B3/V7） -->
          <div v-if="timeline" style="margin-top:16px">
            <div class="tl-head">
              <span class="tl-title">帮带时间轴</span>
              <span class="tl-stat">
                完成 {{ timeline.doneCount }}/{{ timeline.totalCount }}
                <el-tag v-if="timeline.overdueCount" type="danger" size="small">逾期 {{ timeline.overdueCount }}</el-tag>
              </span>
            </div>
            <el-timeline style="margin-top:12px; padding-left:6px">
              <el-timeline-item
                v-for="n in timeline.nodes"
                :key="n.key"
                :type="timelineType(n)"
                :hollow="!n.done"
                :timestamp="n.time ? fmtTime(n.time) : (n.status === 2 ? '已逾期' : '')">
                <div class="tl-node">
                  <span class="tl-node-title" :class="{ done: n.done, overdue: n.status === 2 }">{{ n.title }}</span>
                  <span v-if="n.statusText" class="tl-node-tag">{{ n.statusText }}</span>
                  <span v-if="n.key === 'track' && n.trackDate" class="tl-node-tag">最近 {{ n.trackDate }}</span>
                  <span v-if="n.key === 'assessment' && n.grade" class="tl-node-tag">等级 {{ n.grade }}</span>
                  <span v-if="n.key === 'radar' && n.totalScore != null" class="tl-node-tag">总分 {{ n.totalScore }}</span>
                  <div class="tl-node-desc">{{ n.desc }}</div>
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
        </template>
      </div>
    </el-dialog>

    <!-- 阶段成果归档（D1 第一阶段 doc + 第二阶段在线表单档案） -->
    <el-dialog v-model="archiveVisible" title="阶段成果归档" width="860px">
      <el-tabs v-model="archiveTab">
        <!-- 第一阶段：doc 归档（暑假班续费流程等） -->
        <el-tab-pane label="第一阶段 · 文档归档" name="phase1">
          <el-form :inline="true" @submit.prevent>
            <el-form-item label="关键词">
              <el-input v-model="archiveQuery.keyword" placeholder="导师/文件名" clearable style="width:180px" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="loadArchive">查询</el-button>
            </el-form-item>
          </el-form>

          <el-table :data="archiveList" border v-loading="archiveLoading" size="small" style="width:100%">
            <el-table-column prop="coachName" label="导师" width="130" />
            <el-table-column prop="fileName" label="文件名" min-width="160" show-overflow-tooltip />
            <el-table-column prop="downloadCount" label="下载次数" width="90" />
            <el-table-column label="提报" width="90">
              <template #default="{row}">{{ row.submitStatus === 1 ? '已提交' : '未提交' }}</template>
            </el-table-column>
            <el-table-column label="操作" width="110">
              <template #default="{row}">
                <el-button size="small" type="primary" @click="download(row)">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination style="margin-top:12px" background layout="prev, pager, next, total"
            :total="archiveTotal" :page-size="archiveQuery.size" @current-change="p => { archiveQuery.page = p; loadArchive() }" />
        </el-tab-pane>

        <!-- 第二阶段：在线表单档案（工具1-5/表1-3/雷达 聚合） -->
        <el-tab-pane label="第二阶段 · 在线表单档案" name="phase2">
          <el-form :inline="true" @submit.prevent>
            <el-form-item label="徒弟">
              <el-select v-model="phase2Form.apprenticeId" filterable remote reserve-keyword
                :remote-method="searchApprentice" :loading="coachLoading" placeholder="输入姓名/手机号搜索徒弟"
                style="width:220px" @change="loadPhase2Relations">
                <el-option v-for="c in apprenticeOptions" :key="c.coachid" :label="c.coachname + '（ID:' + c.coachid + '）'" :value="c.coachid" />
              </el-select>
            </el-form-item>
            <el-form-item label="结对关系">
              <el-select v-model="phase2Form.relationId" placeholder="选择该徒弟的一段结对" clearable style="width:240px" @change="loadPhase2">
                <el-option v-for="r in phase2Relations" :key="r.relation.id"
                  :label="(r.mentorName || '导师#' + r.relation.mentorId) + ' → ' + (r.apprenticeName || '徒弟#' + r.relation.apprenticeId) + '（' + (r.relation.pairPeriodStart || '') + ' 起）'"
                  :value="r.relation.id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="loadPhase2">查看档案</el-button>
            </el-form-item>
          </el-form>

          <div v-loading="phase2Loading" style="min-height:160px">
            <el-empty v-if="!phase2Profile && !phase2Loading" description="选择徒弟与结对关系后查看第二阶段档案" />
            <template v-if="phase2Profile">
              <el-descriptions :column="2" border size="small">
                <el-descriptions-item label="导师">{{ phase2Profile.mentorName || '-' }}</el-descriptions-item>
                <el-descriptions-item label="徒弟">{{ phase2Profile.apprenticeName || '-' }}</el-descriptions-item>
                <el-descriptions-item label="阶段">{{ stageText(phase2Profile.relation ? phase2Profile.relation.stage : null) }}</el-descriptions-item>
                <el-descriptions-item label="状态">{{ statusText(phase2Profile.relation ? phase2Profile.relation.status : null) }}</el-descriptions-item>
              </el-descriptions>

              <el-table :data="phase2Rows" border size="small" style="margin-top:12px">
                <el-table-column prop="item" label="环节" width="200" />
                <el-table-column prop="time" label="提交时间" width="170" />
                <el-table-column prop="status" label="状态" width="110" />
                <el-table-column prop="note" label="说明" min-width="180" />
              </el-table>

              <el-alert v-if="phase2Profile.radar" type="info" :closable="false" show-icon style="margin-top:12px"
                :title="'最新健康度：' + healthText(phase2Profile.radar.healthType) + '（学习' + phase2Profile.radar.learningScore + ' / 影响' + phase2Profile.radar.influenceScore + ' / 乐趣' + phase2Profile.radar.funScore + ' / 回报' + phase2Profile.radar.rewardScore + '）'" />
            </template>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <!-- 阶段流转（B3：加添燃料→聚焦长板→实现价值） -->
    <el-dialog v-model="stageVisible" title="阶段流转" width="460px">
      <el-alert type="info" :closable="false" show-icon style="margin-bottom:12px"
        :title="'当前阶段：' + stageText(stageRow.relation ? stageRow.relation.stage : null)" />
      <el-form label-width="90px">
        <el-form-item label="流转至">
          <el-select v-model="stageForm.toStage" style="width:100%">
            <el-option :value="1" label="加添燃料期" />
            <el-option :value="2" label="聚焦长板期" />
            <el-option :value="3" label="实现价值期" />
          </el-select>
        </el-form-item>
        <el-form-item label="原因">
          <el-input v-model="stageForm.reason" type="textarea" :rows="3" placeholder="选填：流转依据/节点说明" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="stageVisible = false">取消</el-button>
        <el-button type="primary" :loading="stageSaving" @click="doChangeStage">确认流转</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mentorAdminRelations, mentorAdminUnpair, mentorAdminImportPairs, mentorSearchCoach, mentorAdminProgress, mentorTimeline, mentorArchiveList, mentorArchiveDownload, mentorFormProfile, mentorAdminChangeStage } from '@/api/mentor'
import { ElMessage, ElMessageBox } from 'element-plus'

export default {
  name: 'MentorRelationManage',
  data () {
    return {
      loading: false,
      total: 0,
      tableData: [],
      operatorId: Number(localStorage.getItem('sysUserId') || localStorage.getItem('userId') || 1),
      query: { page: 1, size: 10, status: null },
      // 新建结对
      pairVisible: false,
      pairing: false,
      coachLoading: false,
      mentorOptions: [],
      apprenticeOptions: [],
      pairForm: { mentorId: null, apprenticeId: null, pairPeriodStart: '', pairPeriodEnd: '' },
      // 批量导入
      importVisible: false,
      importing: false,
      importText: '',
      importResult: null,
      // 培养进度
      progressVisible: false,
      progressLoading: false,
      progressTitle: '',
      progress: null,
      timeline: null,
      // 阶段成果归档（D1）
      archiveVisible: false,
      archiveLoading: false,
      archiveList: [],
      archiveTotal: 0,
      archiveQuery: { page: 1, size: 10, keyword: '' },
      // 第二阶段：在线表单档案
      archiveTab: 'phase1',
      phase2Loading: false,
      phase2Relations: [],
      phase2Profile: null,
      phase2Form: { apprenticeId: null, relationId: null },
      // 阶段流转
      stageVisible: false,
      stageSaving: false,
      stageRow: {},
      stageForm: { toStage: 2, reason: '' }
    }
  },
  mounted () { this.load() },
  computed: {
    progressRows () {
      const p = this.progress
      if (!p) return []
      const tools = p.tools || {}
      const row = (name, done, extra) => ({ name, status: done ? extra : '未完成' })
      const rows = []
      rows.push(row('工具一·职业兴趣', tools.tool1, this.toolStatusText(tools.tool1 && tools.tool1.status)))
      rows.push(row('工具二·性格适配', tools.tool2, this.toolStatusText(tools.tool2 && tools.tool2.status)))
      rows.push(row('工具三·价值观职业锚', tools.tool3, this.toolStatusText(tools.tool3 && tools.tool3.status)))
      rows.push(row('工具四·能力地图', tools.tool4, this.toolStatusText(tools.tool4 && tools.tool4.status)))
      rows.push(row('工具五·四大黄金问题', tools.tool5, this.toolStatusText(tools.tool5 && tools.tool5.status)))
      rows.push(row('表1·目标设定', p.goalSettingDone, '已完成'))
      rows.push(row('表2·月度追踪', p.trackCount > 0, p.trackCount + ' 次'))
      rows.push(row('表3·综合考核', p.assessmentDone, '已完成'))
      return rows
    },
    // 第二阶段归档表格行（profile 聚合 → 行）
    phase2Rows () {
      const p = this.phase2Profile
      if (!p) return []
      const rows = []
      const fmt = (t) => (t || '').replace('T', ' ').substring(0, 16)
      const toolStatus = (s) => s === 2 ? '已复核' : (s === 1 ? '已提交待复核' : '')
      const toolNote = (m) => (m.mentorScore != null ? '导师评分 ' + m.mentorScore : '')
      for (let t = 1; t <= 5; t++) {
        const m = p['tool' + t]
        rows.push({
          item: ['工具一·职业兴趣', '工具二·性格适配', '工具三·价值观职业锚', '工具四·能力地图', '工具五·四大黄金问题'][t - 1],
          time: fmt(m ? m.submitTime : null),
          status: m ? toolStatus(m.status) : '未提交',
          note: m ? toolNote(m) : '—'
        })
      }
      rows.push({ item: '表1·目标设定', time: fmt(p.goalSetting ? p.goalSetting.createTime : null), status: p.goalSetting ? '已提交' : '未提交', note: p.goalSetting ? (p.goalSetting.mentorAdvice ? '导师建议已填' : '—') : '—' })
      rows.push({ item: '表2·月度追踪', time: fmt(p.trackRecord ? p.trackRecord.createTime : null), status: p.trackRecord ? '已提交' : '未提交', note: p.trackRecord ? (p.trackRecord.mentorSupport ? '导师支持已填' : '—') : '—' })
      rows.push({ item: '表3·综合考核', time: fmt(p.assessment ? p.assessment.createTime : null), status: p.assessment ? (p.assessment.signedByMentor === 1 ? '导师已复核' : '已提交待复核') : '未提交', note: p.assessment ? (p.assessment.grade ? '等级 ' + p.assessment.grade : '—') : '—' })
      return rows
    }
  },
  methods: {
    async load () {
      this.loading = true
      const params = { page: this.query.page, size: this.query.size }
      if (this.query.status != null) params.status = this.query.status
      const r = await mentorAdminRelations(params)
      this.loading = false
      if (r && r.code === 200) {
        this.tableData = r.data.records || []
        this.total = r.data.total || 0
      } else {
        ElMessage.warning((r && r.message) || '查询失败')
      }
    },
    reset () { this.query.status = null; this.query.page = 1; this.load() },
    onPage (p) { this.query.page = p; this.load() },
    stageText (s) { return ['', '加添燃料期', '聚焦长板期', '实现价值期'][s] || s },
    statusText (s) { return ['', '已结对', '进行中', '已完成', '已解绑'][s] || s },
    statusTag (s) { return ['', 'success', 'primary', 'info', 'danger'][s] || '' },
    goRadar (relationId) { this.$router.push('/mentorRadar?relationId=' + relationId) },
    // 培养进度总览
    healthText (t) { return ['', '全面健康', '结构性失衡', '全面预警'][t] || '-' },
    toolStatusText (s) { return s === 2 ? '已复核' : '已提交待复核' },
    async showProgress (relationId) {
      this.progressVisible = true
      this.progressLoading = true
      this.progress = null
      this.timeline = null
      const [pr, tl] = await Promise.all([
        mentorAdminProgress({ relationId }),
        mentorTimeline({ relationId })
      ])
      this.progressLoading = false
      if (pr && pr.code === 200) {
        this.progress = pr.data
        this.progressTitle = '培养进度 · ' + pr.data.mentorName + ' 带 ' + pr.data.apprenticeName
      } else {
        ElMessage.warning((pr && pr.message) || '加载失败')
      }
      if (tl && tl.code === 200) this.timeline = tl.data
    },
    // 时间轴辅助
    timelineType (n) {
      if (n.status === 2) return 'danger'
      return n.done ? 'success' : 'info'
    },
    fmtTime (t) {
      if (!t) return ''
      return String(t).replace('T', ' ').substring(0, 16)
    },
    // ============ 阶段成果归档（D1）============
    async openArchive () {
      this.archiveVisible = true
      this.archiveTab = 'phase1'
      this.archiveQuery = { page: 1, size: 10, keyword: '' }
      this.loadArchive()
    },
    async loadArchive () {
      this.archiveLoading = true
      const params = { page: this.archiveQuery.page, size: this.archiveQuery.size }
      if (this.archiveQuery.keyword) params.keyword = this.archiveQuery.keyword
      const r = await mentorArchiveList(params)
      this.archiveLoading = false
      if (r && r.code === 200 && r.data) {
        this.archiveList = r.data.records || []
        this.archiveTotal = r.data.total || 0
      } else {
        ElMessage.warning((r && r.message) || '归档加载失败')
      }
    },
    async download (row) {
      const r = await mentorArchiveDownload({ id: row.id })
      if (r && r.code === 200) {
        ElMessage.success('已记录下载，累计 ' + r.data + ' 次')
        row.downloadCount = r.data
      }
      // 打开/下载链接
      if (row.fileUrl) {
        const a = document.createElement('a')
        a.href = row.fileUrl
        a.target = '_blank'
        a.rel = 'noopener'
        a.click()
      }
    },
    // ============ 第二阶段归档：在线表单档案 ============
    // 选徒弟 → 拉该徒弟的结对关系列表
    async loadPhase2Relations (apprenticeId) {
      this.phase2Form.relationId = null
      this.phase2Relations = []
      this.phase2Profile = null
      if (!apprenticeId) return
      const r = await mentorAdminRelations({ page: 1, size: 20, apprenticeId })
      if (r && r.code === 200) this.phase2Relations = r.data.records || []
    },
    // 选关系 → 拉职业画像聚合（工具1-5/表1-3/雷达）
    async loadPhase2 () {
      const rid = this.phase2Form.relationId
      if (!rid) { ElMessage.warning('请先选择徒弟与结对关系'); return }
      this.phase2Loading = true
      this.phase2Profile = null
      const r = await mentorFormProfile({ relationId: rid })
      this.phase2Loading = false
      if (r && r.code === 200) {
        const p = r.data || {}
        // 补名字
        const rel = this.phase2Relations.find(x => x.relation.id === rid)
        p.mentorName = p.mentorName || (rel ? rel.mentorName : '')
        p.apprenticeName = p.apprenticeName || (rel ? rel.apprenticeName : '')
        p.relation = rel ? rel.relation : null
        this.phase2Profile = p
      } else {
        ElMessage.warning((r && r.message) || '档案加载失败')
      }
    },
    // 进度明细行
    doUnpair (relationId) {
      ElMessageBox.prompt('解绑原因', '确认解绑', { inputType: 'textarea' })
        .then(({ value }) => mentorAdminUnpair({ relationId, reason: value || '' }))
        .then(r => { if (r && r.code === 200) { ElMessage.success('已解绑'); this.load() } else ElMessage.warning((r && r.message) || '操作失败') })
        .catch(() => {})
    },
    // 阶段流转（商学院管理者操作）
    changeStage (row) {
      this.stageRow = row
      this.stageForm = { toStage: 2, reason: '' }
      this.stageVisible = true
    },
    async doChangeStage () {
      const relationId = this.stageRow.relation ? this.stageRow.relation.id : null
      if (!relationId) { ElMessage.warning('关系ID缺失'); return }
      const current = this.stageRow.relation.stage
      if (current === this.stageForm.toStage) { ElMessage.warning('阶段未变化'); return }
      this.stageSaving = true
      const r = await mentorAdminChangeStage({
        relationId,
        toStage: this.stageForm.toStage,
        operatorId: this.operatorId,
        reason: this.stageForm.reason || ''
      })
      this.stageSaving = false
      if (r && r.code === 200) {
        ElMessage.success(r.data || '已流转')
        this.stageVisible = false
        this.load()
      } else {
        ElMessage.warning((r && r.message) || '流转失败')
      }
    },
    // 教练搜索（远程下拉）
    async searchMentor (kw) { this.mentorOptions = await this.searchCoach(kw) },
    async searchApprentice (kw) { this.apprenticeOptions = await this.searchCoach(kw) },
    async searchCoach (kw) {
      if (!kw) return []
      this.coachLoading = true
      const r = await mentorSearchCoach({ name: kw })
      this.coachLoading = false
      if (r && r.code === 200 && r.data) {
        return Array.isArray(r.data) ? r.data : (r.data.records || [])
      }
      return []
    },
    // 新建结对（单条）
    async doPair () {
      const f = this.pairForm
      if (!f.mentorId || !f.apprenticeId || !f.pairPeriodStart || !f.pairPeriodEnd) {
        ElMessage.warning('请选择导师/徒弟并填写完整周期')
        return
      }
      this.pairing = true
      const rows = [{
        mentorId: f.mentorId,
        apprenticeId: f.apprenticeId,
        pairPeriodStart: f.pairPeriodStart,
        pairPeriodEnd: f.pairPeriodEnd,
        areaId: 0 // 商学院整体结对，0=不限城市
      }]
      const r = await mentorAdminImportPairs(rows)
      this.pairing = false
      if (r && r.code === 200) {
        if (r.data.failCount) {
          ElMessage.warning('结对失败：' + (r.data.failed[0] ? r.data.failed[0].reason : ''))
        } else {
          ElMessage.success('结对成功')
          this.pairVisible = false
          this.pairForm = { mentorId: null, apprenticeId: null, pairPeriodStart: '', pairPeriodEnd: '' }
          this.load()
        }
      } else {
        ElMessage.warning((r && r.message) || '操作失败')
      }
    },
    // 批量导入（每行：导师id,徒弟id,开始,结束；商学院整体结对）
    parseImportRows () {
      const rows = []
      const lines = this.importText.split(/\r?\n/).map(s => s.trim()).filter(Boolean)
      for (const line of lines) {
        const parts = line.split(/[,，]/).map(s => s.trim())
        if (parts.length < 4) continue
        rows.push({
          mentorId: parts[0],
          apprenticeId: parts[1],
          pairPeriodStart: parts[2],
          pairPeriodEnd: parts[3],
          areaId: 0 // 商学院整体，不限城市
        })
      }
      return rows
    },
    async doImport () {
      const rows = this.parseImportRows()
      if (!rows.length) { ElMessage.warning('未解析到有效数据行'); return }
      this.importing = true
      const r = await mentorAdminImportPairs(rows)
      this.importing = false
      if (r && r.code === 200) {
        this.importResult = r.data
        if (!r.data.failCount) { ElMessage.success('批量结对成功 ' + r.data.successCount + ' 条') }
        this.load()
      } else {
        ElMessage.warning((r && r.message) || '导入失败')
      }
    }
  }
}
</script>

<style scoped>
:deep(.el-card) { border-radius: 12px; box-shadow: 0 2px 8px rgba(31, 45, 61, .08); }
:deep(.el-card__header) { font-weight: 600; background: #fafbfc; border-radius: 12px 12px 0 0; }
:deep(.el-button) { border-radius: 6px; }
.tl-head { display: flex; align-items: center; justify-content: space-between; padding: 8px 10px; background: #f7f8fa; border-radius: 8px; }
.tl-title { font-weight: 600; font-size: 14px; }
.tl-stat { display: flex; align-items: center; gap: 8px; font-size: 13px; color: #606266; }
.tl-node { line-height: 1.5; }
.tl-node-title { font-weight: 600; font-size: 14px; color: #303133; }
.tl-node-title.done { color: #67c23a; }
.tl-node-title.overdue { color: #f56c6c; }
.tl-node-tag { display: inline-block; margin-left: 8px; padding: 0 8px; border-radius: 10px; background: #ecf5ff; color: #409eff; font-size: 12px; line-height: 20px; vertical-align: 1px; }
.tl-node-desc { color: #909399; font-size: 12px; margin-top: 2px; }
</style>
